import { gql } from '@apollo/client'
import contractChangeFragment from '../contract/fragments/contractChange.fragment'
import latestContractFragment from '../contract/fragments/latestContract.fragment'
import salaryOfYearFragment from '../contract/fragments/salaryOfYearFragment'
import targetBonusOfYearFragment from '../contract/fragments/targetBonusOfYear.fragment'
import contractValidityInYearFragment from '../contract/fragments/contractValidityInYear.fragment'
import fullObjectiveFragment from './../../graphql/objectives/ObjectiveDTO.fragment'
import fullObjectivePaymentFragment from './../objectivePayments/fullObjectivePayment.fragment'
import fullOneOffPaymentFragment from './fullOneOffPayment.fragment'

export const FIND_ONE_OFF_PAYMENTS_BY_MEETING_ID = gql`
  query oneOffPaymentByMeetingId($meetingId: HashedId!) {
    oneOffPaymentByMeetingId(meetingId: $meetingId) {
      ...FullOneOffPayment
    }
  }
  ${fullOneOffPaymentFragment}
`
export const ONE_OFF_PAYMENT_OBJECTIVE_PAYMENT_TARGET_CORRECTION_PAYMENT_TARGET_BONUSOF_YEAR_WITH_OBJECTIVES = gql`
  query oneOffPaymentObjectivePaymentTargetCorrectionPaymentTargetBonusOfYearAndObjectives(
    $employeeId: HashedId!
    $meetingId: HashedId!
    $year: Int!
    $includeAllTargetBoni: Boolean = false
  ) {
    oneOffPaymentByMeetingId: oneOffPaymentByMeetingId(meetingId: $meetingId) {
      ...FullOneOffPayment
    }
    objectivesInMeeting(meetingId: $meetingId) {
      ...fullObjectiveFragment
    }
    objectivePayment: objectivePaymentByMeeting(id: $meetingId) {
      ...FullObjectivePayment
    }
    targetBonusOfYear(employeeId: $employeeId, year: $year, includeAll: $includeAllTargetBoni) {
      ...TargetBonusOfYear
    }
    targetCorrectionPaymentByMeetingId(meetingId: $meetingId) {
      id
      paymentDate
      status
      resultAmount
      comment
      referenceYear
      meetingId
      paymentDateValid
    }
    isOneOffPaymentNotAllowed(meetingId: $meetingId)
    targetCorrectionPaymentAllowedYears(meetingId: $meetingId) {
      currentYearAllowed
      previousYearAllowed
    }
  }
  ${fullObjectiveFragment}
  ${fullOneOffPaymentFragment}
  ${fullObjectivePaymentFragment}
  ${targetBonusOfYearFragment}
`

export const ONE_OFF_PAYMENT_AND_OBJECTIVE_PAYMENTS_WITH_OBJECTIVES = gql`
  query oneOffPaymentAndObjectivePaymentsWithObjectives($meetingId: HashedId!) {
    oneOffPaymentByMeetingId: oneOffPaymentByMeetingId(meetingId: $meetingId) {
      ...FullOneOffPayment
    }
    objectivesInMeeting(meetingId: $meetingId) {
      ...fullObjectiveFragment
    }
    objectivePayment: objectivePaymentByMeeting(id: $meetingId) {
      ...FullObjectivePayment
    }
    isOneOffPaymentNotAllowed(meetingId: $meetingId)
  }
  ${fullObjectiveFragment}
  ${fullOneOffPaymentFragment}
  ${fullObjectivePaymentFragment}
`

export const ONE_OFF_PAYMENT_AND_OBJECTIVE_PAYMENTS_WITH_OBJECTIVES_AND_TARGET_BONUS_AND_CONTRACT_CHANGES_AND_CURRENT_CONTRACT = gql`
  query oneOffPaymentAndObjectivePaymentsWithObjectivesAndTargetBonusAndContractChangesAndCurrentContract(
    $employeeId: HashedId!
    $meetingId: HashedId!
    $year: Int!
    $newTargetsYear: Int!
    $country: Country!
    $includeAllTargetBoni: Boolean = false
    $includeGovernmentJobTitles: Boolean = false
  ) {
    oneOffPaymentByMeetingId: oneOffPaymentByMeetingId(meetingId: $meetingId) {
      ...FullOneOffPayment
    }
    objectivesInMeeting(meetingId: $meetingId) {
      ...fullObjectiveFragment
    }
    objectivePayment: objectivePaymentByMeeting(id: $meetingId) {
      ...FullObjectivePayment
    }
    targetBonusOfYear(employeeId: $employeeId, year: $year, includeAll: $includeAllTargetBoni) {
      ...TargetBonusOfYear
    }
    salaryOfYear(employeeId: $employeeId, year: $year, includeAll: $includeAllTargetBoni) {
      ...SalaryOfYear
    }
    contractsInYear(employeeId: $employeeId, year: $year) {
      ...ContractValidityInYear
    }
    newTargetsTargetBonusOfYear: targetBonusOfYear(employeeId: $employeeId, year: $newTargetsYear, includeAll: $includeAllTargetBoni) {
      ...TargetBonusOfYear
    }
    newTargetsSalaryOfYear: salaryOfYear(employeeId: $employeeId, year: $newTargetsYear, includeAll: $includeAllTargetBoni) {
      ...SalaryOfYear
    }
    newTargetsContractsInYear: contractsInYear(employeeId: $employeeId, year: $newTargetsYear) {
      ...ContractValidityInYear
    }
    contractChangesByEmployee(employeeId: $employeeId) {
      ...ContractChange
    }
    currentContract(employeeId: $employeeId) {
      ...LatestContractDTO
    }
    branchOfficeByEmployee(employeeId: $employeeId) {
      code
      name
      timezone
      addressId
    }
    isBonusValidationEnabled(country: $country)
    isOneOffPaymentNotAllowed(meetingId: $meetingId)
    existingDevObjectivesToBeClosedInMeeting(meetingId: $meetingId)
    governmentJobTitlesByEmployeeId(employeeId: $employeeId) @include(if: $includeGovernmentJobTitles) {
      id
      hiringOffice {
        id
        code
      }
      department
      title
      level
      monthlySalaryMinimum
      monthlySalaryMaximum
      currency
      sortOrder
    }
  }
  ${fullObjectiveFragment}
  ${fullOneOffPaymentFragment}
  ${fullObjectivePaymentFragment}
  ${targetBonusOfYearFragment}
  ${salaryOfYearFragment}
  ${contractChangeFragment}
  ${latestContractFragment}
  ${contractValidityInYearFragment}
`
